module.exports = __webpack_public_path__ + "img/seven5Orange.4a58fb51.jpg";